<div class="container">
  <form
    *ngIf="formConfig"
    class="form-striped"
    data-testid="initiate-form"
  >
    <form-field
      *ngIf="shouldShowSsn()"
      [config]="formConfig!.ssn"
    ></form-field>

    <form-field [config]="formConfig!.code"></form-field>
    <div class="alert alert-danger ms-2" data-testid="code-exists-message" *ngIf="displayCodeExists$ | async">
      {{ "uploadErrorCodeNotUnique" | localize }}
    </div>

    <form-field *ngIf="initiationType==='ORDERED'" [config]="formConfig!.operatorHospital"></form-field>

    <form-field [config]="formConfig!.type"></form-field>

    <form-field [config]="formConfig!.reasonForStudy"></form-field>

    <form-field [config]="formConfig!.deviceSerial" *ngIf="shouldShowDeviceSerial()"></form-field>

    <div>
      <action-button
        [buttonType]="'button'"
        [buttonLabel]="submitButtonLabel"
        [actionInProgressLabel]="submitActionInProgressLabel"
        [actionInProgress]="initiateInProgress$ | async"
        (buttonClick)="initiateMeasurement()"
        [testId]="'submit-button'">
      </action-button>

      <span data-testid="submit-error-message" *ngIf="!!errorMessage" class="alert alert-danger ms-2">
        {{ errorMessage | localize }}
      </span>
    </div>

  </form>
</div>
